import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-461ed912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "charts-dashboard" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = { class: "charts-dashboard__header" }
const _hoisted_4 = { class: "charts-dashboard__header-left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "charts-dashboard__header-cta" }
const _hoisted_8 = {
  key: 0,
  class: "charts-dashboard__note"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "charts-dashboard__pro-feature-modal" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "charts-dashboard__overlay" }, null, -1))
const _hoisted_13 = { class: "charts-dashboard__theme-navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_RequestProcessesModal = _resolveComponent("RequestProcessesModal")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_PxNavigationTab = _resolveComponent("PxNavigationTab")!
  const _component_ListReportsView = _resolveComponent("ListReportsView")!
  const _component_ProcessReportsView = _resolveComponent("ProcessReportsView")!
  const _component_MilestonProgressReportsView = _resolveComponent("MilestonProgressReportsView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("chartsDashboard.title")), 1),
          (_ctx.showPagesNavigation)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_5, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: _normalizeClass({
                  active: _ctx.selectedPage === index,
                  disabled: _ctx.loading,
                }),
                      onClick: ($event: any) => (_ctx.selectedPage = index)
                    }, _toDisplayString(page), 11, _hoisted_6))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.showRequestProcessCta && !_ctx.isFreeUser)
            ? (_openBlock(), _createBlock(_component_PxButton, _mergeProps({ key: 0 }, _ctx.requestProcessButtonProps, {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showProcessModal = true), ["stop"]))
              }), null, 16))
            : _createCommentVNode("", true),
          _createVNode(_component_RequestProcessesModal, {
            visibility: _ctx.showProcessModal,
            "onUpdate:visibility": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showProcessModal) = $event)),
            "show-overlay": "",
            "show-close": "",
            "title-path": "chartsDashboard.requestProcessesModal.title[1]"
          }, null, 8, ["visibility"])
        ]),
        (_ctx.isFreeUser || _ctx.showMockDataCopy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_PxIcon, {
                name: "information--light-gray",
                size: "16"
              }),
              _createElementVNode("i", {
                innerHTML: _ctx.$t('chartsDashboard.mockData')
              }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("main", null, [
        (_ctx.isFreeUser)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("header", null, [
                  _createVNode(_component_PxIcon, {
                    size: 60,
                    name: "private"
                  }),
                  _createElementVNode("h1", null, _toDisplayString(_ctx.proFeatureModalProps.title), 1),
                  _createElementVNode("p", {
                    innerHTML: _ctx.proFeatureModalProps.description
                  }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("footer", null, [
                  _createVNode(_component_PxButton, {
                    label: _ctx.proFeatureModalProps.ctaLabel,
                    type: "blue",
                    onClick: _ctx.goToSubscriptionPage
                  }, null, 8, ["label", "onClick"])
                ])
              ]),
              _hoisted_12
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createVNode(_component_PxNavigationTab, {
            "selected-tab": _ctx.selectedNavbarId,
            "onUpdate:selectedTab": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedNavbarId) = $event)),
            "navigation-tabs": _ctx.navBarItems,
            "show-number": false,
            "list-format": false,
            class: _normalizeClass({
              'charts-dashboard__theme-navigation--disabled':
                _ctx.isFreeUser || _ctx.loading,
            })
          }, null, 8, ["selected-tab", "navigation-tabs", "class"]), [
            [_vShow, _ctx.showThemeNavigation]
          ])
        ]),
        (_ctx.selectedTheme)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.showListReportsView)
                ? (_openBlock(), _createBlock(_component_ListReportsView, {
                    key: 0,
                    theme: _ctx.selectedTheme,
                    onLoading: _ctx.setLoading,
                    onShowNavigation: _ctx.setThemeNavigationVisibility
                  }, null, 8, ["theme", "onLoading", "onShowNavigation"]))
                : _createCommentVNode("", true),
              (_ctx.showProcessReportsView)
                ? (_openBlock(), _createBlock(_component_ProcessReportsView, {
                    key: 1,
                    theme: _ctx.selectedTheme,
                    onLoading: _ctx.setLoading,
                    onShowMockData: _ctx.setMockDataCopyVisibility
                  }, null, 8, ["theme", "onLoading", "onShowMockData"]))
                : _createCommentVNode("", true),
              (_ctx.showMilestonProgressReportsView)
                ? (_openBlock(), _createBlock(_component_MilestonProgressReportsView, {
                    key: 2,
                    theme: _ctx.selectedTheme,
                    onLoading: _ctx.setLoading
                  }, null, 8, ["theme", "onLoading"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}